import axios from 'axios'
import {ConfigFileService} from "@/services/ConfigFileService";
import {ResponseMessageType} from "@/types/ResponseMessageType";
import {OrderListResponseType} from "@/types/OrderListResponseType";

class InternalOrderService {
    async getOrderByEmail(email:string, channelCode:string|null): Promise<OrderListResponseType> {
        const res = await axios.get(`${ConfigFileService.apiUrl}api/cic/customer/${email}/orders`, {
            params: {
                channel: channelCode,
            }
        })
            .catch(function (error) {
                throw error.response.data
            })

        return res.data
    }

    async getOrder(number:string): Promise<any> {
        const res = await axios.get(`${ConfigFileService.apiUrl}api/cic/order/${number}`)
            .catch(function (error) {
                throw error.response.data
            })

        return res.data
    }

    async sendOrderConfirmation(number:string, locale:string): Promise<ResponseMessageType> {
        const res = await axios.post(`${ConfigFileService.apiUrl}api/cic/order/${number}/send-confirmation-email`, {},{
            headers: {
                'accept-language': locale,
            }
        })
            .catch(function (error) {
                throw error.response.data
            })

        return res.data
    }

    async sendInvoice(number:string, invoicePdf:string, locale:string): Promise<ResponseMessageType> {
        const res = await axios.post(`${ConfigFileService.apiUrl}api/cic/order/${number}/send-invoice`, {'invoicePdf': invoicePdf}, {
            headers: {
                'accept-language': locale,
            }
        })
            .catch(function (error) {
                throw error.response.data
            })

        return res.data
    }

    async sendShipmentConfirmation(number:string, shipmentId:number, locale:string): Promise<ResponseMessageType> {
        const res = await axios.post(`${ConfigFileService.apiUrl}api/cic/order/${number}/shipments/${shipmentId}/send-shipment-email`,{}, {
            headers: {
                'accept-language': locale,
            }
        })
            .catch(function (error) {
                throw error.response.data
            })

        return res.data
    }

}

export const OrderService = new InternalOrderService()
